<template>
    <div class="wrap">
        <Verify v-if="sub_page === 'verify'"></Verify>
        <PharmInfo v-if="sub_page === 'pharminfo'"></PharmInfo>
        <Admin v-if="sub_page === 'admin'"></Admin>
        <Password v-if="sub_page === 'password'"></Password>
    </div>
</template>

<script>
    import Verify from '@/components/Settings/Verify.vue'
    import PharmInfo from '@/components/Settings/PharmInfo.vue'
    import Admin from '@/components/Settings/Admin.vue'
    import Password from '@/components/Settings/Password.vue'
  export default {
    name: 'settings',
    data () {
      return {
        sub_page: null
      }
    },
    methods: {
      set_sub_page () {
        let {sub_page} = this.$route.params
        // console.log('sub_page', sub_page)
        if (sub_page) {
          this.sub_page = sub_page
        } else {
          this.$router.push('/settings/verify')
        }
      }
    },
    mounted () {
      // 초기값을 넣어주면 좋겠당
      this.set_sub_page()
    },
    watch: {
      '$route' (to, from) {
        this.set_sub_page()
      }
    },
    components: {Verify, Password, PharmInfo, Admin}
  }
</script>

<style scoped>
    /* Contents
    ------------------------------------------------------- */
    .wrap {
        width: 100%;
        max-width: 1280px;
        margin: 55px auto;
    }
</style>